import { render, staticRenderFns } from "./TeamSearch.vue?vue&type=template&id=0753f2f8&scoped=true&"
import script from "./TeamSearch.vue?vue&type=script&lang=js&"
export * from "./TeamSearch.vue?vue&type=script&lang=js&"
import style0 from "./TeamSearch.vue?vue&type=style&index=0&id=0753f2f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0753f2f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
